import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { SettingsService } from '@app/services/settings/settings.service';
import { SeoService } from '@app/services/seo.service';

/**
 * Core agency initialization provider for multitenant application.
 *
 * Ensures critical agency-specific data is loaded before app bootstrap:
 * 1. Loads agency settings (name, domain, features) from API with per-domain caching
 * 2. Initializes SEO service with correct agency metadata for SSR
 *
 * This blocks SSR rendering to ensure social media crawlers receive correct
 * meta tags (title, description, og:tags) in the initial HTML response.
 */
export const AgencyCoreInitializerProvider: EnvironmentProviders = provideAppInitializer(async () => {
  const settingsService = inject(SettingsService);
  const seoService = inject(SeoService);

  // Load settings first - critical for agency-specific configuration
  await settingsService.loadSettings().then(() => {
    // Initialize SEO with loaded settings to ensure correct meta tags for SSR
    seoService.initialize();
  });
});
